import script from "./RadioControlPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RadioControlPage.vue?vue&type=script&setup=true&lang=js"

import "./RadioControlPage.vue?vue&type=style&index=0&id=38ef48cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38ef48cd"]])

export default __exports__